// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemno-input[data-v-b2ea498e] {\n  max-width: 6.5em;\n}\n.itemdesc-input[data-v-b2ea498e] {\n  min-width: 15em;\n}\n.money-input[data-v-b2ea498e] {\n  max-width: 5.5em;\n}\n.total-input[data-v-b2ea498e] {\n  min-width: 5.5em;\n}\n.qty-input[data-v-b2ea498e] {\n  max-width: 3.5em;\n}\n.partno-input[data-v-b2ea498e] {\n  min-width: 6.5em;\n}", ""]);
// Exports
module.exports = exports;
